import React from 'react';

import H2 from 'components/typo/Heading/H2';
import P from 'components/typo/P';
import { ImageList } from 'components/ImageList';
import { List } from 'components/ImageList/types';
import { useTranslation } from 'lib/i18n';

import shoptetImage from '../images/shoptet.png';
import presta16Image from '../images/prestaShop16.png';
import presta17Image from '../images/prestaShop17.png';
import rychleImage from '../images/eshopRychle.png';
import fastImage from '../images/fastcentrik.png';
import floxImage from '../images/flox.png';
import shopifyImage from '../images/shopify.png';
import shopioImage from '../images/shopio.png';

const platformList: List = [
  {
    id: 1,
    logo: shopifyImage,
    name: 'shopify',
    href: 'integration/files',
    target: '_self',
    internalLink: true,
    params: { id: 'shopify' },
  },
  {
    id: 2,
    logo: shoptetImage,
    name: 'shoptet',
    href: 'integration/files',
    target: '_self',
    internalLink: true,
    params: { id: 'shoptet' },
  },
  {
    id: 3,
    logo: presta16Image,
    name: 'PrestaShop 1.6',
    href: 'integration/files',
    target: '_self',
    internalLink: true,
    params: { id: 'prestaShop16' },
  },
  {
    id: 4,
    logo: presta17Image,
    name: 'PrestaShop 1.7',
    href: 'integration/files',
    target: '_self',
    internalLink: true,
    params: { id: 'prestaShop17' },
  },
  {
    id: 5,
    logo: rychleImage,
    name: 'eshoprychle',
    href: 'integration/files',
    target: '_self',
    internalLink: true,
    params: { id: 'eshoprychle' },
  },
  {
    id: 6,
    logo: fastImage,
    name: 'FASTCentrik',
    href: 'integration/files',
    target: '_self',
    internalLink: true,
    params: { id: 'fastcentrik' },
  },
  {
    id: 7,
    logo: shopioImage,
    name: 'Shopio',
    href: 'integration/files',
    target: '_self',
    internalLink: true,
    params: { id: 'advisorIntegrationGuide' },
  },
  {
    id: 8,
    logo: floxImage,
    name: 'Flox3',
    href: 'integration/files',
    target: '_self',
    internalLink: true,
    params: { id: 'flox3' },
  },
];

const PlatformsIndex: React.FC = () => {
  const { t } = useTranslation('pages');
  return (
    <>
      <H2>{t('integration.platforms.title')}</H2>
      <P bigOnDesktop>{t('integration.platforms.description')}</P>
      <ImageList square big list={platformList} />
    </>
  );
};
export default PlatformsIndex;
